<template>
  <v-app class="rdrive-shell">
      <v-app-bar border="b" flat height="56">
        <div class="d-flex align-center overflow-x-auto px-2" style="max-width: calc(100% - 68px);">
          <v-btn
            v-for="item in navItems"
            :key="item.name"
            :to="{ name: item.name }"
            class="text-none"
            :icon="$vuetify.display.xsOnly"
            :active="route.name === item.name"
            :min-width="$vuetify.display.xsOnly ? 40 : undefined"
            density="compact"
          >
            <v-icon size="20">{{ item.icon }}</v-icon>
            <span
              v-if="$vuetify.display.smAndUp"
              class="ms-1 text-body-2"
            >
              {{ item.text }}
            </span>
          </v-btn>
        </div>

        <slot name="app-bar-append"></slot>

        <v-spacer></v-spacer>

        <v-btn
          icon
          density="compact"
          class="ms-auto"
          style="min-width: 40px;"
        >
          <v-menu location="bottom end" :close-on-content-click="true">
            <template v-slot:activator="{ props }">
              <v-btn icon v-bind="props" density="compact">
                <v-icon size="20">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="emit('toggleTheme')">
                <template v-slot:prepend>
                  <v-icon>mdi-theme-light-dark</v-icon>
                </template>
                <v-list-item-title>
                  {{ t('switchTheme', { theme: $vuetify.theme.global.current.dark ? t('themeLight') : t('themeDark') }) }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="toggleFullscreen">
                <template v-slot:prepend>
                  <v-icon>{{ isFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
                </template>
                <v-list-item-title>
                  {{ isFullscreen ? t('exitFullscreen') : t('fullscreen') }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="showDuckDBDialog = true">
                <template v-slot:prepend>
                  <v-icon>mdi-duck</v-icon>
                </template>
                <v-list-item-title>
                  {{ t('duckdbQuery') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-btn>
      </v-app-bar>

      <v-dialog v-model="showMissingParams" persistent max-width="400">
        <v-card>
          <v-card-title class="text-h5">
            {{ t('missingParamsTitle') }}
          </v-card-title>
          <v-card-text>
            {{ t('missingParamsText') }}
            <ul class="mt-2">
              <li v-for="param in missingParams" :key="param" class="mt-1">
                {{ param }}
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="closeMissingParams">
              {{ t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DuckDB Query Dialog -->
      <DuckDBQueryDialog
        v-model="showDuckDBDialog"
        :exporting="exporting"
        :query="queryRunner"
        @export="emit('export')"
      />

      <v-main>
        <div class="pa-4 content-container">
          <slot></slot>

          <WelcomeDialog
            v-bind="welcome"
            v-model="welcomeOpen"
            @load="emit('load')"
            @copy-query-string="emit('copyQueryString')"
            @marketing-item-open="emit('marketingItemOpen', $event)"
            @marketing-item-visit="emit('marketingItemVisit', $event)"
          />

          <slot name="fab"></slot>
        </div>
      </v-main>
  </v-app>
</template>

<script src="./model.js"></script>
<style src="./style.css"></style>
